import React, { useState } from "react";
// import NumberFormat from 'react-number-format';
import { NumericFormat } from 'react-number-format';

// Mol
import General2PlanCardMol from '../../../../Molecules/Cards/Plan/General2'
// import Modal, { ModalSize } from "../../../../Molecules/Modal";
// import MChannelsPartModal from '../../Modal/Part/MChannels'
// import MServiceHomePartModal from "../../../../Molecules/Modal/Part/MServiceHome";
// import MSolicitarPartModal from '../../Modal/Part/MSolicitar'



import { v4 as uuid } from "uuid";

function CardsWrap(props) {
  const { planes, tituloSolicitarPlan, descSolicitarPlan, changeSolicitud, setSeEstaRegistrando } = props;
  
  const [planSelected, setPlanSelected] = useState(-1);

  const AmountPonderacion = localStorage.getItem("AmountPonderacion")
    ? parseInt(localStorage.getItem("AmountPonderacion"))
    : 0;
  let filPlanMb1 = 75
  let filPlanMb2 = 100
  if(AmountPonderacion >= 9 && AmountPonderacion < 13){
    filPlanMb1 = 100
    filPlanMb2 = 300
  }
  if(AmountPonderacion >= 13 && AmountPonderacion < 15){
    filPlanMb1 = 300
    filPlanMb2 = 400
  }
  if(AmountPonderacion >= 15 && AmountPonderacion < 17){
    filPlanMb1 = 400
    filPlanMb2 = 500
  }
  if(AmountPonderacion >= 17 ){
    filPlanMb1 = 500
    filPlanMb2 = 1024
  }

  function getplanIdeal() {    
    planes.map(p => {
      let Velocidad_descarga = p.fc_NOMBRE.toUpperCase()
      let text = " MBPS"
      if (Velocidad_descarga.search(text) === -1){
          text = "GB"
      }
      let getMegas_SUBIDA = Velocidad_descarga.split(text)[0]
      // console.log("Velocidad_descarga: TEXT", text, getMegas_SUBIDA, Velocidad_descarga)
      if (getMegas_SUBIDA.search(" ")){
          let ArrayGetMegas_SUBIDA = []
          ArrayGetMegas_SUBIDA = Array.from(getMegas_SUBIDA.split(" "))
          // console.log("Velocidad_descarga:", ArrayGetMegas_SUBIDA)
          ArrayGetMegas_SUBIDA.map((element, index) =>{
              if (parseInt(element)){
                  getMegas_SUBIDA = parseInt(element)
                  if ( text === "GB" ){
                      getMegas_SUBIDA = parseInt(element) * 1024
                  }
              }
              return element
          })
      }
      // console.log("Velocidad_descarga:", text, "getMegas_SUBIDA: ", getMegas_SUBIDA)
      p.caracteristicas.map((caract, index)=>{
          caract.megas_SUBIDA = getMegas_SUBIDA;
          return caract
      })
      p.megas_SUBIDA = getMegas_SUBIDA
      // console.log('p.fc_NOMBRE', AmountPonderacion, filPlanMb1, filPlanMb2, p.fi_PLAN, getMegas_SUBIDA, p.fc_NOMBRE)
      return p
    })

    // console.log("getplanIdeal:", filPlanMb1, filPlanMb2, planes);
    let listPlanes = [];

    let planesIdeales = planes?.find((p) => p.megas_SUBIDA === filPlanMb1);
    let planesIdealesMax = planes?.find((p) => p.megas_SUBIDA === filPlanMb2);
    // console.log("getplanIdeal:", planesIdeales, planesIdealesMax, newPlanes);

    if (!planesIdeales) {
      planesIdeales = planes.find((p) => {
        return p.caracteristicas.find(
          (c) => c.megas_SUBIDA === filPlanMb1
        );
      });
    }

    if (!planesIdealesMax) {
      planesIdeales = planes.find((p) => {
        return p.caracteristicas.find(
          (c) => c.megas_SUBIDA === filPlanMb2
        );
      });
    }
    
    if (planesIdeales) {
      listPlanes[0] = planesIdeales;
    }
    if (planesIdeales?.fi_PLAN !== planesIdealesMax?.fi_PLAN) {
      listPlanes[1] = planesIdealesMax;
    }
    return listPlanes;
  }
  
  let planIdeal =[]
  if(planes.length > 0){
    planIdeal = getplanIdeal();
  }
  
  const changePlanSelected = (idPlan) => {
    if(idPlan){
      setPlanSelected(idPlan)
    }
  }
  const cotUsername = localStorage.getItem("cotUsername") ? localStorage.getItem("cotUsername") : null;
  const cotUsermail = localStorage.getItem("cotUsermail") ? localStorage.getItem("cotUsermail") : null;
  const cotUserphone = localStorage.getItem("cotUserphone") ? localStorage.getItem("cotUserphone") : null;
  
  console.log("planIdeal", planIdeal);
  // const datosNecesarios = localStorage.getItem("cotUserphone") && localStorage.getItem("cotUsermail") && localStorage.getItem("cotUsername");

  const PlayPLanData = planIdeal.length ? planIdeal.map((item, index) => (
    <div className={'cCotCardsSld ' + (planSelected === item.fi_PLAN && (!cotUsername && !cotUsermail && !cotUserphone) ? 'selected' : '')}  style={{display: (planSelected > 0 && planSelected !== item.fi_PLAN) ? 'none' : ''}} key={uuid()} data-idplan={item.fi_PLAN}>
        <General2PlanCardMol
            setSeEstaRegistrando={setSeEstaRegistrando}
            key={uuid()}
            title={item.fc_TEXTO_CAJA}
            titlestyle={item.fc_COLOR_CAJA ? item.fc_COLOR_CAJA.toLowerCase() : null}
            name={item.fc_NOMBRE}
            // changeCompare={handleChangeCompare}
            fi_PLAN={item.fi_PLAN}
            fi_ID_TELEFONIA={item.fi_ID_TELEFONIA}
            fi_ID_TELEVISION={item.fi_ID_TELEVISION}
            fi_ID_INTERNET={item.fi_ID_INTERNET}
            fi_CATEGORIA={item.fi_CATEGORIA}
            fc_TIPO_DISPONIBILIDAD={item.fc_TIPO_DISPONIBILIDAD}
            fc_TEXTO_CAJA={item.fc_TEXTO_CAJA}
            fc_COLOR_CAJA={item.fc_COLOR_CAJA}
            fc_NOMBRE={item.fc_NOMBRE}
            fc_DESCRIPCION={item.fc_DESCRIPCION}
            fi_NUMERO_CARACTERISTICAS_MOSTRAR={item.fi_NUMERO_CARACTERISTICAS_MOSTRAR}
            fc_TITULO_CARACTERISTICAS_AGRUPADAS={item.fc_TITULO_CARACTERISTICAS_AGRUPADAS}
            fi_PRECIO_PLAN={<NumericFormat thousandSeparator={","} decimalSeparator={"."} displayType={'text'} value={Number.isInteger(item.fi_PRECIO_PLAN) ? item.fi_PRECIO_PLAN + ".00" : item.fi_PRECIO_PLAN.toFixed(2)} />}
            fi_PRECIO_TELEFONIA_ENPS={item.fi_PRECIO_TELEFONIA_ENPS}
            fi_PRECIO_TELEVISION_ESPN={item.fi_PRECIO_TELEVISION_ESPN}
            fi_PRECIO_INTERNET_ESPS={item.fi_PRECIO_INTERNET_ESPS}
            fc_COLOR_PRECIO={item.fc_COLOR_PRECIO}
            fc_ETIQUETA_PRECIO_TACHADO={item.fc_ETIQUETA_PRECIO_TACHADO}
            fc_PRECIO_TACHADO={<NumericFormat thousandSeparator={","} decimalSeparator={"."} displayType={'text'} value={item.fc_PRECIO_TACHADO.includes(".") ? item.fc_PRECIO_TACHADO : item.fc_PRECIO_TACHADO + ".00"} />}
            Discount={item?.fc_PRECIO_TACHADO > 0 && parseInt(item.fc_PRECIO_TACHADO) !== parseInt(item.fi_PRECIO_PLAN) ? <NumericFormat displayType={'text'} value={(100 - (item.fi_PRECIO_PLAN * 100) / item.fc_PRECIO_TACHADO).toFixed(0)} /> : null}
            fc_NOTA_DEBAJO_PRECIO={item.fc_NOTA_DEBAJO_PRECIO}
            fc_TEXTO_DETALLE={item.fc_TEXTO_DETALLE}
            fc_URL_DETALLE={item.fc_URL_DETALLE}
            fc_TARGET_DETALLE={item.fc_TARGET_DETALLE}
            fi_BAN_DETALLE={item.fi_BAN_DETALLE}
            fc_OPCION_CONTRATACION={item.fc_OPCION_CONTRATACION}
            fc_TEXTO_CONTRATAR={item.fc_TEXTO_CONTRATAR}
            fc_URL_CONTRATAR={item.fc_URL_CONTRATAR}
            fc_TARGET_CONTRATAR={item.fc_TARGET_CONTRATAR}
            fi_BAN_CONTRATAR={item.fi_BAN_CONTRATAR}
            fi_ORDEN={item.fi_ORDEN}
            fi_ACTIVO={item.fi_ACTIVO}
            fi_ID_DASHBOARD={item.fi_ID_DASHBOARD}
            fi_BAN_ENPN={item.fi_BAN_ENPN}
            fi_BAN_ENPS={item.fi_BAN_ENPS}
            fi_BAN_ESPN={item.fi_BAN_ESPN}
            fi_BAN_ESPS={item.fi_BAN_ESPS}
            fc_ETIQUETA_PROMOCION_ATP={item.fc_ETIQUETA_PROMOCION_ATP}
            fi_PRECIO_AHORRO={item.fi_PRECIO_AHORRO}
            fc_ETIQUETA_PERIODO={item.fc_ETIQUETA_PERIODO}
            fc_TITULO_PROMO={item.fc_TITULO_PROMO}
            Caracteristicas={item.caracteristicas}
            caracteristicasPromocion={item.caracteristicasPromocion}
            Acordeon={item.acordeon}
            lstPlanContratacionxPlan={item.lstPlanContratacionxPlan}
            // keysPlanCompare={keysPlanCompare}
            fi_INCLUIR_SECCION={item.fi_INCLUIR_SECCION}
            fc_ETIQUETA_ROJA={item.fc_ETIQUETA_ROJA}
            fc_TITULO_SECCION={item.fc_TITULO_SECCION}
            fc_DESCRIPCION_SECCION={item.fc_DESCRIPCION_SECCION}
            fc_TEXTO_BOTON={item.fc_TEXTO_BOTON}
            fc_TARGET_BOTON={item.fc_TARGET_BOTON}
            fc_URL_BOTON={item.fc_URL_BOTON}
            fc_DESCRIPCION_OFERTA={item.fc_DESCRIPCION_OFERTA}
            fc_PLAN_ICONO={item.fc_PLAN_ICONO}
            fc_NOTA_DETALLE_PROMOCION={item?.fc_NOTA_DETALLE_PROMOCION}
            // dataChannelsBk={dataChannelsBk}
            // dataCategoriasBk={dataCategoriasBk}
            // dataPlanChannelsBk={dataPlanChannelsBk}
            tituloSolicitarPlan={tituloSolicitarPlan}
            descSolicitarPlan={descSolicitarPlan}
            changePlanSelected={changePlanSelected}
            planSelected={planSelected}
            changeSolicitud={changeSolicitud}
        />
    </div>
)) : null

  return (
    <>
      <div className={`cCotCardsWrap twoPlans ${planSelected>-1 ? 'noBg' : ''}`}>
        <div className={`cCotCardsCarousel ${planSelected>-1 ? 'cotCenter' : ''}`}>
          {PlayPLanData}
        </div>
      </div>
    </>
  );
}

export default CardsWrap;
